module.exports = __webpack_public_path__ + "img/spotify.026e5e2a.svg";